import {
  Layers,
  Image,
  Square,
  BarChart2,
  FileText,
  Settings,
  LayoutTemplate
} from 'lucide-react';
import { useEditorStore } from '../../store/editorStore';
import ElementsPanel from './ElementsPanel';
import MediaPanel from './MediaPanel';
import TemplatesPanel from './TemplatesPanel';
import SettingsPanel from './SettingsPanel';
import LayersPanel from './LayersPanel';
import InteractivePanel from './InteractivePanel';
import FormsPanel from './FormsPanel';

const TABS = [
  { id: 'elements', icon: <Layers size={16} />, label: 'Elements' },
  { id: 'media', icon: <Image size={16} />, label: 'Media' },
  { id: 'templates', icon: <LayoutTemplate size={16} />, label: 'Templates' },
  { id: 'interactive', icon: <BarChart2 size={16} />, label: 'Interactive' },
  { id: 'forms', icon: <FileText size={16} />, label: 'Forms' },
  { id: 'pages', icon: <Square size={16} />, label: 'Layers' },
  { id: 'settings', icon: <Settings size={16} />, label: 'Settings' },
];

export default function Sidebar() {
  const activeSidebarTab = useEditorStore((s) => s.activeSidebarTab);
  const setActiveSidebarTab = useEditorStore((s) => s.setActiveSidebarTab);

  return (
    <div className="flex flex-shrink-0" style={{ borderRight: '1px solid var(--t-border)' }}>
      {/* Tab Icons */}
      <div className="flex flex-col py-2 gap-0.5" style={{
        width: '52px',
        background: 'var(--t-panel)',
        borderRight: '1px solid var(--t-border)',
      }}>
        {TABS.map(({ id, icon, label }) => {
          const isActive = activeSidebarTab === id;
          return (
            <button
              key={id}
              onClick={() => setActiveSidebarTab(id)}
              className="flex flex-col items-center justify-center gap-1 py-2.5 mx-1 rounded-lg transition-colors"
              style={{
                background: isActive ? 'rgba(99,102,241,0.12)' : 'transparent',
                color: isActive ? 'var(--brand-primary)' : 'var(--t-muted)',
                fontFamily: 'Inter, sans-serif',
                position: 'relative',
              }}
              onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = 'var(--t-hover)'; }}
              onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'transparent'; }}
              title={label}
            >
              {isActive && (
                <span style={{
                  position: 'absolute', left: 0, top: '20%', bottom: '20%',
                  width: '2.5px', borderRadius: '0 2px 2px 0',
                  background: 'var(--brand-primary)',
                }} />
              )}
              {icon}
              <span style={{ fontSize: '8.5px', fontWeight: isActive ? 600 : 400, lineHeight: 1, letterSpacing: '0.01em' }}>
                {label}
              </span>
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div className="w-80 overflow-y-auto" style={{ background: 'var(--t-surface)' }}>
        {activeSidebarTab === 'elements' && <ElementsPanel />}
        {activeSidebarTab === 'media' && <MediaPanel />}
        {activeSidebarTab === 'templates' && <TemplatesPanel />}
        {activeSidebarTab === 'interactive' && <InteractivePanel />}
        {activeSidebarTab === 'forms' && <FormsPanel />}
        {activeSidebarTab === 'pages' && <LayersPanel />}
        {activeSidebarTab === 'settings' && <SettingsPanel />}
      </div>
    </div>
  );
}
